import React, { useState } from 'react';

import { FormComponent } from 'components';
import { tableToolbar } from 'styles/table';
import { IUser, ISelectOption, SearchUserFilterType } from 'types';

const STATUS_OPTIONS: ISelectOption<IUser['status']>[] = [
  { name: '정상', value: 'NORMAL' },
  { name: '이용정지', value: 'BLOCK' },
];

interface Props {
  filter: SearchUserFilterType;
  handleFilter: (filter: SearchUserFilterType) => void;
}

function Filter({ handleFilter, filter }: Props) {
  const [status, setStatus] = useState<IUser['status'][]>(
    STATUS_OPTIONS.map((o) => o.value),
  );

  const handleStatus = (value: IUser['status'][]) => {
    setStatus(value);
    handleFilter({
      ...filter,
      status: value.length === 1 ? value[0] : undefined,
    });
  };

  return (
    <div css={tableToolbar}>
      <FormComponent.Form
        submit={(d: SearchUserFilterType) => handleFilter({ ...filter, ...d })}
      >
        <FormComponent.SearchInput
          name="name"
          placeholder="이름으로 검색해주세요"
        />
        <FormComponent.MultiSelect
          title="계정상태"
          options={STATUS_OPTIONS}
          value={status}
          handleChange={handleStatus}
        />
      </FormComponent.Form>
    </div>
  );
}

export default Filter;
